import React, { Fragment } from "react";

const ThemeLayout = (props) => {
  return (
    <Fragment>
      <main className="main sapphire-app-main">{props.children}</main>
    </Fragment>
  );
};

export default ThemeLayout;
